import { render, staticRenderFns } from "./token-dialog.vue?vue&type=template&id=2328a0f0&scoped=true"
import script from "./token-dialog.vue?vue&type=script&lang=js"
export * from "./token-dialog.vue?vue&type=script&lang=js"
import style0 from "./token-dialog.vue?vue&type=style&index=0&id=2328a0f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328a0f0",
  null
  
)

export default component.exports